import balancoApi from "@/app/services/balanco";

export default {
    namespaced: true,
    state: {
        balanco: null,
        balancos: [],
        itens: []
    },

    mutations: {
      listar(state, balancos) {
        state.balancos = balancos;
      },

      abrir(state, balanco) {
        state.balanco = balanco;
      },

      salvar(state, balanco) {
        state.balancos.push(balanco);
      },

      atualizar(state, balanco) {
        let index = state.balancos.findIndex(balanco_ => balanco_.id == balanco.id);
        if (index > -1) {
          state.balancos.splice(index, 1, balanco);
        }
      },

      excluir(state, id) {
        let index = state.balancos.findIndex(balanco => balanco.id == id);
        if (index > -1) {
          state.balancos.splice(index, 1);
        }
      },

      UNSET_BALANCO(state) {
        state.balanco = null;
      },

      ADICIONAR_ITEM(state, item) {
        let index = state.itens.findIndex(item_ => item_.referencia == item.referencia);
        if (index > -1) {
          state.itens.splice(index, 1, item);
        } else {
          state.itens.unshift(item)
        }
      }


    },

    actions: {
      async listar({commit}) {
        commit('LOADING_ON', null, {root: true});
        let balancos = await balancoApi.listar();
        commit('listar', balancos);
        commit('LOADING_OFF', null, {root: true});
      },

      async abrir({commit}, id) {
        commit('LOADING_ON', null, {root: true});
        let balanco = await balancoApi.abrir(id);
        commit('abrir', balanco);
        commit('LOADING_OFF', null, {root: true});
      },

      async salvar({commit, dispatch}, balanco) {
        let novobalanco = await balancoApi.salvar(balanco);
        commit('salvar', novobalanco);
      },

      async atualizar({commit}, balanco) {
        await balancoApi.atualizar(balanco);
        commit('atualizar', balanco);
      },

      async excluir({commit}, id) {
        await balancoApi.excluir(id);
        commit('excluir', id);
      },

      async adicionarItem({commit, dispatch}, item) {
        let novoItem = await balancoApi.adicionarItem(item);
        commit('ADICIONAR_ITEM', novoItem);
      },
    }
}
